"use client"

import { useState } from "react"
import { getArticleReadProgress, useScrollAndResize } from "@/components/marketing/article-read-progress"

// Tiny crimson scroll-progress hairline pinned to the very top of the
// viewport. Visible only below lg — desktop already has the sticky TOC
// card that surfaces % progress.
export function ArticleProgressBar() {
  const [progress, setProgress] = useState(0)

  useScrollAndResize(() => {
    const value = getArticleReadProgress()
    if (value !== null) setProgress(value)
  }, [])

  return (
    <div
      aria-hidden
      className="fixed inset-x-0 top-0 z-50 h-[3px] bg-[var(--color-rule)]/60 lg:hidden"
    >
      <div
        className="h-full bg-[var(--color-vermilion)] transition-[width] duration-150"
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}
